import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//

import { mapActions } from 'vuex';
export default {
  name: 'App',
  created: function created() {
    var _this = this;
    // Send initial check request...
    this.$store.dispatch('common/check');
    // Listen to WebSockets
    this.$echo.channel('app').listen('AppInfo', function (_ref) {
      var info = _ref.info;
      switch (info.msg) {
        case 'app-going-down':
          _this.updateMaintenanceMode(parseInt(info.minutes));
          break;
        case 'app-is-down':
          _this.updateMaintenanceMode('yes');
          break;
        case 'app-is-up':
          _this.updateMaintenanceMode('ready');
          break;
      }
    });
  },
  destroyed: function destroyed() {
    this.$echo.leave('app');
  },
  methods: _objectSpread({}, mapActions('common', ['updateMaintenanceMode', 'check']))
};